import { Dashboard } from '../comum/modelos/dashboard';
import { SettingsService } from '../settings.service';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DashboardUsuario } from '../comum/modelos/dashboard-usuario';
import { ParametroGrafico } from '../comum/modelos/parametro-grafico';
import { MaiorPosicaoGrafico } from '../comum/modelos/maior-posicao-grafico';
import { ResultadoDashboardSingle } from '../comum/modelos/resultado-dashboard-single';
import { ResultadoDashboardMulti } from '../comum/modelos/resultado-dashboard-multi';
import { PontoFisicoParametroGrafico } from '../comum/modelos/ponto-fisico-parametro-grafico';
import { RegiaoParametroGrafico } from '../comum/modelos/regiao-parametro-grafico';
import { TipoPontoFisicoParametroGrafico } from '../comum/modelos/tipo-ponto-fisico-parametro-grafico';
import { UsuarioParametroGrafico } from '../comum/modelos/usuario-parametro-grafico';
import { AreaParametroGrafico } from '../comum/modelos/area-parametro-grafico';

@Injectable()
export class DashboardsService {
  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/dashboards/';
  }

  obterDashboardsHttp(id: number): Observable<Dashboard[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  cadastrarDashboardHttp(dashboard: Dashboard): Observable<HttpResponse<Dashboard>> {
    return this._http
      .post(this._host, dashboard, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarDashboardHttp(dashboard: Dashboard): Observable<HttpResponse<Dashboard>> {
    return this._http
      .put(this._host, dashboard, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerDashboardHttp(idDashboard: number): Observable<HttpResponse<Dashboard>> {
    return this._http.delete(this._host + idDashboard, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  obterDashboardPorIdHttp(id: number): Observable<Dashboard> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterDashboardUsuarios(id: number): Observable<DashboardUsuario[]> {
    return this._http.get(this._host + 'usuario/' + id)
      .catch(this.handleError);
  }

  cadastrarDashboardUsuariosHttp(dashboardUsuarios: DashboardUsuario[]):
    Observable<HttpResponse<DashboardUsuario[]>> {
    return this._http
      .post(this._host + 'usuario/', dashboardUsuarios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarDashboardUsuariosHttp(dashboardUsuarios: DashboardUsuario[]):
    Observable<HttpResponse<DashboardUsuario[]>> {
    return this._http
      .put(this._host + 'usuario/', dashboardUsuarios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterParametrosGraficosHttp(id: number): Observable<ParametroGrafico[]> {
    return this._http.get(this._host + 'parametro-grafico/' + id)
      .catch(this.handleError);
  }

  cadastrarParametroGraficoHttp(parametroGrafico: ParametroGrafico): Observable<HttpResponse<ParametroGrafico>> {
    return this._http
      .post(this._host + 'parametro-grafico/', parametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarParametroGraficoHttp(parametroGrafico: ParametroGrafico): Observable<HttpResponse<ParametroGrafico>> {
    return this._http
      .put(this._host + 'parametro-grafico/', parametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerParametroGraficoHttp(idParametroGrafico: number): Observable<HttpResponse<ParametroGrafico>> {
    return this._http.delete(this._host + 'parametro-grafico/' + idParametroGrafico, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  obterMaiorPosicaoGraficoHttp(id: number): Observable<MaiorPosicaoGrafico> {
    return this._http.get(this._host + 'parametro-grafico/maior-posicao/' + id)
      .catch(this.handleError);
  }

  obterDashboardSingleHttp(parametro: ParametroGrafico): Observable<HttpResponse<ResultadoDashboardSingle>> {
    return this._http.post(this._host + 'grafico/single/', parametro, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterDashboardMultiHttp(parametro: ParametroGrafico): Observable<HttpResponse<ResultadoDashboardMulti>> {
    return this._http.post(this._host + 'grafico/multi/', parametro, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterPontosFisicosParametroGraficoHttp(id: number): Observable<PontoFisicoParametroGrafico[]> {
    return this._http.get(this._host + 'ponto-fisico/' + id)
      .catch(this.handleError);
  }

  cadastrarPontosFisicosParametroGraficoHttp(pontosFisicosParametroGrafico: PontoFisicoParametroGrafico[]):
    Observable<HttpResponse<PontoFisicoParametroGrafico[]>> {
    return this._http
      .post(this._host + 'ponto-fisico/', pontosFisicosParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerPontosFisicosParametroGraficoHttp(pontosFisicosParametroGrafico: PontoFisicoParametroGrafico[]):
    Observable<HttpResponse<PontoFisicoParametroGrafico[]>> {
    return this._http
      .patch(this._host + 'ponto-fisico/', pontosFisicosParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterTiposPontoFisicoParametroGraficoHttp(id: number): Observable<TipoPontoFisicoParametroGrafico[]> {
    return this._http.get(this._host + 'tipo-ponto-fisico/' + id)
      .catch(this.handleError);
  }

  cadastrarTiposPontoFisicoParametroGraficoHttp(tiposPontoFisicoParametroGrafico: TipoPontoFisicoParametroGrafico[]):
    Observable<HttpResponse<TipoPontoFisicoParametroGrafico[]>> {
    return this._http
      .post(this._host + 'tipo-ponto-fisico/', tiposPontoFisicoParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerTiposPontoFisicoParametroGraficoHttp(tiposPontoFisicoParametroGrafico: TipoPontoFisicoParametroGrafico[]):
    Observable<HttpResponse<TipoPontoFisicoParametroGrafico[]>> {
    return this._http
      .patch(this._host + 'tipo-ponto-fisico/', tiposPontoFisicoParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterRegioesParametroGraficoHttp(id: number): Observable<RegiaoParametroGrafico[]> {
    return this._http.get(this._host + 'regiao/' + id)
      .catch(this.handleError);
  }

  cadastrarRegioesParametroGraficoHttp(regioesParametroGrafico: RegiaoParametroGrafico[]):
    Observable<HttpResponse<RegiaoParametroGrafico[]>> {
    return this._http
      .post(this._host + 'regiao/', regioesParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerRegioesParametroGraficoHttp(regioesParametroGrafico: RegiaoParametroGrafico[]):
    Observable<HttpResponse<RegiaoParametroGrafico[]>> {
    return this._http
      .patch(this._host + 'regiao/', regioesParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterUsuariosParametroGraficoHttp(id: number): Observable<UsuarioParametroGrafico[]> {
    return this._http.get(this._host + 'usuario-parametro-grafico/' + id)
      .catch(this.handleError);
  }

  cadastrarUsuariosParametroGraficoHttp(usuariosParametroGrafico: UsuarioParametroGrafico[]):
    Observable<HttpResponse<UsuarioParametroGrafico[]>> {
    return this._http
      .post(this._host + 'usuario-parametro-grafico/', usuariosParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerUsuariosParametroGraficoHttp(usuariosParametroGrafico: UsuarioParametroGrafico[]):
    Observable<HttpResponse<UsuarioParametroGrafico[]>> {
    return this._http
      .patch(this._host + 'usuario-parametro-grafico/', usuariosParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterAreasParametroGraficoHttp(id: number): Observable<AreaParametroGrafico[]> {
    return this._http.get(this._host + 'area/' + id)
      .catch(this.handleError);
  }

  cadastrarAreasParametroGraficoHttp(areasParametroGrafico: AreaParametroGrafico[]):
    Observable<HttpResponse<AreaParametroGrafico[]>> {
    return this._http
      .post(this._host + 'area/', areasParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAreasParametroGraficoHttp(areasParametroGrafico: AreaParametroGrafico[]):
    Observable<HttpResponse<AreaParametroGrafico[]>> {
    return this._http
      .patch(this._host + 'area/', areasParametroGrafico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/dashboards.service.ts